import moment from "moment";
import React from "react";
import Tooltip from "@/src/components/common/Elements/Tooltip/Tooltip";
import { connect } from "react-redux";
@connect(store => {
    return {
        loggedUser: store.loggedUser,
        conversations: store.conversations

    }
})

class Actions extends React.Component {
    render() {
        const { message, loggedUser, dispatch,conversations } = this.props;
        const allowEdit = message.raw && message.raw.trim().length >0  && (message.isDeleted === 0 ||  !message.isDeleted);
        const onEdit = (message)=>{
            const selectedMessage = conversations.selectedMessages
            // UPDATE_CONVERSATIONS_SELECTED_MESSAGES
             dispatch({type:"UPDATE_CONVERSATIONS_SELECTED_MESSAGES",messages:selectedMessage.map(s=>{
                 if(s.id === message.id) {
                     return {
                         ...s,
                         forEdit:true
                     }
                 } else {
                     delete s.forEdit
                     return s
                 }
             })})
        }
        const onDelete =(message)=>{

            dispatch({ type: "SET_CONVERSATIONS_MSG_SELECTED", selected: {...message, action:''}});
            $(`#deletedMsgModal`).modal("show");
            
            // call delete modal
            
        }
        const onReply=(message)=>{

            dispatch({ type: "SET_CONVERSATIONS_MSG_SELECTED", selected: {...message, action:'reply'}});
            // call delete modal
            
        }
        return (
            <div class="message-actions">
                <div class={`message-time`}>
                    {/* <span>{ moment( message.dateAdded ).format( "HH:mm" ) }</span> */}
                    <span>{moment(message.dateAdded).format(!moment(moment(message.dateAdded).format("MM/DD/YYYY")).isSame(moment().format("MM/DD/YYYY")) ? "h:mm A on DD-MMM YYYY" : "h:mm A")}</span>
                </div>
                <div class="action-items">
                    <a class="action-item reply"   data-tooltip-id="reply-tooltip" onClick={(e)=>{e.preventDefault();onReply(message)}}>
                        <i class="material-icons">reply</i>
                    </a>
                    <Tooltip id="reply-tooltip" place="bottom" effect="solid">
                        Reply
                    </Tooltip>

                    { loggedUser.data.id === message.users.id && (
                        <React.Fragment>
                            <a class={`action-item edit ${allowEdit ? "" : "hidden"}`}   data-tooltip-id="edit-tooltip" onClick={(e)=>{e.preventDefault();onEdit(message)}}>
                                <i class="material-icons">edit</i>
                            </a>
                            <Tooltip id="edit-tooltip" place="bottom" effect="solid">
                                Edit
                            </Tooltip>

                            <a class="action-item delete"   data-tooltip-id="delete-tooltip" onClick={(e)=>{e.preventDefault();onDelete(message)}}>
                                <i class="material-icons">delete_outline</i>
                            </a>
                            <Tooltip id="delete-tooltip" place="bottom" effect="solid">
                                Delete
                            </Tooltip>
                        </React.Fragment>
                    )}
                </div>
            </div>
        )
    }
}

export default Actions;